/* assets/zr-cart.js */
(function () {
  const cartRoot = document.querySelector('.zr-cart');
  const form = document.querySelector('.zr-cart__form');
  if (!form) return;

  // -------------------------
  // Helpers
  // -------------------------
  let updateTimer = null;

  function setUpdating(isUpdating) {
    if (!cartRoot) return;
    cartRoot.classList.toggle('is-updating', isUpdating);
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('no-NO', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NOK'
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' kr';
    }
  }

  // -------------------------
  // Free shipping UI (main cart)
  // Priority:
  // 1) data-attrs on #zr-ship (Liquid)
  // 2) window.ZR_FREE_SHIP_* (optional global)
  // -------------------------
  const shipWrap = document.getElementById('zr-ship');
  const shipLabel = document.getElementById('zr-ship-label') || shipWrap?.querySelector('.zr-ship__label');
  const shipValue = document.getElementById('zr-ship-value') || shipWrap?.querySelector('.zr-ship__value');
  const shipFill = document.getElementById('zr-ship-fill') || shipWrap?.querySelector('.zr-ship__fill');
  const shipBar = shipWrap?.querySelector('.zr-ship__bar');

  function getShipEnabled() {
    if (shipWrap && shipWrap.hasAttribute('data-free-ship-enabled')) {
      return shipWrap.getAttribute('data-free-ship-enabled') === 'true';
    }
    // fallback (default false to prevent "always on")
    return (window.ZR_FREE_SHIP_ENABLED != null) ? !!window.ZR_FREE_SHIP_ENABLED : false;
  }

  function getShipThresholdCents() {
    if (shipWrap && shipWrap.hasAttribute('data-free-ship-threshold')) {
      const n = parseInt(shipWrap.getAttribute('data-free-ship-threshold') || '0', 10);
      return Number.isFinite(n) ? n : 0;
    }
    // fallback expects cents already
    const n = (window.ZR_FREE_SHIP_THRESHOLD != null) ? Number(window.ZR_FREE_SHIP_THRESHOLD) : 0;
    return Number.isFinite(n) ? n : 0;
  }

  function updateFreeShipping(subtotalCents) {
    if (!shipWrap || !shipLabel || !shipValue || !shipFill) return;

    if (!getShipEnabled()) {
      shipWrap.style.display = 'none';
      return;
    }

    const threshold = getShipThresholdCents(); // cents

    // threshold = 0 => always free shipping
    if (threshold <= 0) {
      shipWrap.style.display = 'block';
      shipLabel.textContent = 'Gratis frakt';
      shipValue.textContent = 'Gratis frakt på alle ordre';
      shipFill.style.width = '100%';
      if (shipBar) shipBar.setAttribute('aria-valuenow', '100');
      return;
    }

    // hide if empty
    if (!subtotalCents || subtotalCents <= 0) {
      shipWrap.style.display = 'none';
      return;
    }

    shipWrap.style.display = 'block';

    const remaining = Math.max(0, threshold - subtotalCents);
    let pct = Math.max(0, Math.min(100, Math.round((subtotalCents / threshold) * 100)));

    if (remaining <= 0) {
      shipLabel.textContent = 'Gratis frakt';
      shipValue.textContent = 'Aktivert ✅';
      pct = 100;
    } else {
      shipLabel.textContent = 'Nær gratis frakt';
      shipValue.textContent = 'Mangler ' + money(remaining);
    }

    shipFill.style.width = pct + '%';
    if (shipBar) shipBar.setAttribute('aria-valuenow', String(pct));
  }

  // init on page load (subtotal from Liquid)
  if (window.ZR_CART_SUBTOTAL_CENTS != null) {
    updateFreeShipping(Number(window.ZR_CART_SUBTOTAL_CENTS));
  }

  // -------------------------
  // Inventory clamp (client-side)
  // -------------------------
  function clampQty(input, desired) {
    const maxAttr = input.getAttribute('data-max');
    const max = (maxAttr != null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;

    let d = parseInt(desired, 10);
    if (Number.isNaN(d)) d = 0;
    if (d < 0) d = 0;

    if (max != null && !Number.isNaN(max)) d = Math.min(d, max);
    return d;
  }

  function syncQtyUI(row) {
    const input = row.querySelector('.zr-cart__qtyInput');
    const minus = row.querySelector('[data-qty-minus]');
    const plus = row.querySelector('[data-qty-plus]');
    const hint = row.querySelector('[data-qty-hint]');
    if (!input) return;

    const maxAttr = input.getAttribute('data-max');
    const max = (maxAttr != null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;

    const val = parseInt(input.value || '0', 10) || 0;
    const atMax = (max != null && !Number.isNaN(max) && val >= max);

    if (plus) {
      plus.disabled = atMax;
      plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      plus.title = atMax ? 'Maks tilgjengelig antall' : '';
    }

    if (hint) {
      if (atMax) {
        hint.style.display = 'block';
        hint.textContent = 'Maks ' + max + ' tilgjengelig';
      } else {
        hint.style.display = 'none';
        hint.textContent = '';
      }
    }

    if (minus) {
      minus.disabled = false;
      minus.setAttribute('aria-disabled', 'false');
    }
  }

  // -------------------------
  // Update cart via /cart/change.js (then reload)
  // -------------------------
  async function postChange(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || 'change_failed');
    }
    return res.json();
  }

  async function applyQty(row, desired) {
    const input = row.querySelector('.zr-cart__qtyInput');
    if (!input) return;

    const key = input.getAttribute('data-key');
    if (!key) return;

    const next = clampQty(input, desired);

    input.value = String(next);
    syncQtyUI(row);

    try {
      setUpdating(true);
      await postChange(key, next);
      window.location.reload();
    } catch (err) {
      console.error('ZR cart update failed:', err);

      try {
        const c = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
        const it = (c.items || []).find(x => String(x.key) === String(key));
        if (it) input.value = String(it.quantity);
        updateFreeShipping(c.items_subtotal_price || 0);
      } catch (_) {}

      syncQtyUI(row);
      alert('Ops! Kunne ikke oppdatere antall. Sjekk lager og prøv igjen.');
      setUpdating(false);
    }
  }

  // -------------------------
  // Bind rows: +/- + remove
  // -------------------------
  document.querySelectorAll('.zr-cart__row').forEach((row) => {
    const input = row.querySelector('.zr-cart__qtyInput');
    const minus = row.querySelector('[data-qty-minus]');
    const plus = row.querySelector('[data-qty-plus]');
    const remove = row.querySelector('[data-remove]');
    if (!input) return;

    syncQtyUI(row);

    minus?.addEventListener('click', () => {
      const cur = parseInt(input.value || '0', 10) || 0;
      applyQty(row, cur - 1);
    });

    plus?.addEventListener('click', () => {
      const cur = parseInt(input.value || '0', 10) || 0;
      applyQty(row, cur + 1);
    });

    input.addEventListener('input', () => {
      const n = parseInt(input.value || '0', 10);
      if (Number.isNaN(n)) return;

      input.value = String(clampQty(input, n));
      syncQtyUI(row);

      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => applyQty(row, input.value), 450);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyQty(row, input.value);
      }
    });

    remove?.addEventListener('click', () => {
      applyQty(row, 0);
    });
  });

  // -------------------------
  // Clear cart (dialog) -> reload
  // -------------------------
  const clearBtn = document.querySelector('[data-zr-cart-clear]');
  const dialog = document.getElementById('zrCartClearConfirm');
  const cancel = dialog?.querySelector('[data-zr-cart-cancel]');
  const confirm = dialog?.querySelector('[data-zr-cart-confirm]');

  const openDialog = () => {
    if (dialog?.showModal) dialog.showModal();
    else if (window.confirm('Tømme handlekurven?')) doClear();
  };

  const closeDialog = () => {
    if (dialog?.close) dialog.close();
  };

  async function doClear() {
    try {
      if (clearBtn) clearBtn.disabled = true;
      setUpdating(true);

      const res = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      });

      if (!res.ok) throw new Error('Could not clear cart');
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert('Klarte ikke å tømme handlekurven. Prøv igjen.');
      if (clearBtn) clearBtn.disabled = false;
      setUpdating(false);
    }
  }

  clearBtn?.addEventListener('click', openDialog);
  cancel?.addEventListener('click', closeDialog);
  confirm?.addEventListener('click', () => {
    closeDialog();
    doClear();
  });

  // Click outside to close (fix: use clientX/clientY correctly)
  dialog?.addEventListener('click', (evt) => {
    const rect = dialog.getBoundingClientRect();
    const inDialog =
      rect.top <= evt.clientY && evt.clientY <= rect.top + rect.height &&
      rect.left <= evt.clientX && evt.clientX <= rect.left + rect.width;

    if (!inDialog) closeDialog();
  });

    // -------------------------
  // Checkout (support both type="button" + data-checkout and normal submit)
  // -------------------------
  document.querySelectorAll('[data-checkout]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      // If button is not a submit, we force checkout in a Shopify-safe way
      if (btn.type !== 'submit') e.preventDefault();

      // Preferred: submit cart form with name="checkout"
      if (form) {
        const hidden = document.createElement('button');
        hidden.type = 'submit';
        hidden.name = 'checkout';
        hidden.style.display = 'none';
        form.appendChild(hidden);
        hidden.click();
        hidden.remove();
        return;
      }

      // Fallback
      window.location.href = '/checkout';
    });
  });
})();